<template>
  <DBox
    :id="'settings-accounting-ai_options-invoice_reminder'"
    :addButton="false"
    :addLink="false"
  >
    <Dropdown2
      :label="$t('notify_to')"
      :options="notifyToOptions"
      class="dbox1"
      :listHeight="250"
      :showLabel="true"
      :bb="'0px'"
      :selected="notifyToOptions.find((v) => v.value == selectedNotifyTo)"
      v-on:selectedChange="(e) => onNotityToChange(e)"
    />
  </DBox>
</template>
<script>
import { mapGetters } from "vuex";
import store from "../../../../store";
import * as AccountTypes from "../../../../store/app/account/types";
import { AccountingSettingsService } from "../../services/accounting-settings.service";

export default {
  data: () => ({
    notifyToOptions: [
      { text: "Responsible agent", value: "responsible" },
      { text: "Accounting person", value: "user_id" },
      { text: "Client contact", value: "client_admin" },
    ],
    selectedNotifyTo: "",
  }),
  computed: {
    ...mapGetters({
      account: "account",
    }),
  },
  mounted() {
    const settings = JSON.parse(this.account?.client?.settings);
    this.selectedNotifyTo = settings?.AI?.invoice_reminder?.notify_to
      ? settings.AI.invoice_reminder.notify_to
      : "responsible";
  },
  methods: {
    async onNotityToChange(e) {
      this.selectedNotifyTo = e.value;
      const aiSettings = await AccountingSettingsService.aiUpdateFeatureProp(
        "invoice_reminder",
        "notify_to",
        e.value
      );
      console.log("aiSettings", aiSettings);

      store.dispatch(AccountTypes.GET_APP_INIT_DATA);
    },
  },
};
</script>
<style scoped>
.settings-accounting-ai_options-invoice_reminder {
  padding-bottom: 1px;
}
</style>